
<div *ngIf="tour | async; let tour" [ngStyle]="{'text-align':'center'}">
		<h3 *ngIf="tour.artistemail">Do you really want to sent by email the routing to the artist?</h3> 
    <button mat-button *ngIf="tour.artistemail"
    	(click)="sendEmail(tour.artistemail,tour.$key,tour.title,tour.artistlastname,tour.artistfirstname);removeSendEmail()" cdkFocusInitial>YES</button>	
		<button mat-button (click)="onNoClick()">NO</button>		
</div>	